/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportsRequestStateChangeRequest } from '../../models/auth-supports-request-state-change-request';

export interface ChangeAuthSupportsRequestState$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * The new state for an auth supports request
     */
    body: AuthSupportsRequestStateChangeRequest
}

export function changeAuthSupportsRequestState(http: HttpClient, rootUrl: string, params: ChangeAuthSupportsRequestState$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeAuthSupportsRequestState.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeAuthSupportsRequestState.PATH = '/custom/auth-supports-requests/{uid}/state';
